import { useEditCameraStore } from "../editCameraStore/editCameraStore";

export const HIGH_SENSITIVITY_LABEL = "High (more sensitive)";

export const hasSensitivitySelected = (optionId: unknown): boolean =>
  optionId !== null && optionId !== undefined && optionId !== "";

export const getHighSensitivityOptionId = (
  options: unknown
): number | null => {
  if (!Array.isArray(options)) {
    return null;
  }
  const highOption = options.find(
    (option) =>
      Array.isArray(option) &&
      option[0] === HIGH_SENSITIVITY_LABEL &&
      option[1] !== undefined
  );
  return Array.isArray(highOption) ? highOption[1] : null;
};

export const applyDefaultHighSensitivityIfUnset = (metric: {
  option_id?: unknown;
  options?: unknown;
}): void => {
  if (hasSensitivitySelected(metric.option_id)) {
    return;
  }
  const highOptionId = getHighSensitivityOptionId(metric.options);
  if (highOptionId !== null) {
    metric.option_id = highOptionId;
  }
};

export const shouldApplyAutopatrolHighSensitivityDefault = (): boolean => {
  const { siteInfoEditCamera, vCHOnlySite } = useEditCameraStore.getState();
  return (
    siteInfoEditCamera?.integration_type_name === "autopatrol" && !vCHOnlySite
  );
};

const getMediumOrFirstOptionId = (options: unknown): number | null => {
  if (!Array.isArray(options)) {
    return null;
  }
  const mediumOption = options.find(
    (option) =>
      Array.isArray(option) &&
      typeof option[0] === "string" &&
      option[0].toLowerCase() === "medium"
  );
  if (Array.isArray(mediumOption) && mediumOption[1] !== undefined) {
    return mediumOption[1];
  }
  const firstOption = options.find(
    (option) => Array.isArray(option) && option[1] !== undefined
  );
  return Array.isArray(firstOption) ? firstOption[1] : null;
};

export const resolveMetricOptionIdForSubmit = (
  currentMetric: {
    option_id?: unknown;
    options?: unknown;
    active?: boolean;
  },
  previousMetric: { option_id?: unknown; options?: unknown } | null,
  isPostRequest: boolean,
  applyAutopatrolHighSensitivityDefault: boolean
): number | null | undefined => {
  if (hasSensitivitySelected(currentMetric.option_id)) {
    return currentMetric.option_id as number;
  }

  if (isPostRequest && currentMetric.option_id === undefined) {
    if (hasSensitivitySelected(previousMetric?.option_id)) {
      return previousMetric?.option_id as number;
    }
  }

  if (applyAutopatrolHighSensitivityDefault && currentMetric.active) {
    const highOptionId = getHighSensitivityOptionId(
      currentMetric.options ?? previousMetric?.options
    );
    if (highOptionId !== null) {
      return highOptionId;
    }
  }

  if (isPostRequest) {
    return getMediumOrFirstOptionId(
      currentMetric.options ?? previousMetric?.options
    );
  }

  return currentMetric.option_id as number | null | undefined;
};
